/* ready */
$(function () {
  'use strict';

  $('.p-top-mv__slide').slick({
    autoplay: true,
    arrows: false,
    dots: true,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: '0',
    appendDots: $('.p-top-mv__dots'),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerPadding: '18%'
        },
      },
    ],
  }).on('beforeChange', function (e, s, c, n) {
    $('.slick-dots li').removeClass('is-end');
    $('.slick-dots li').slice(0, n).addClass('is-end');

    let width = $('.slick-dots li').width();
    let between = $('.slick-dots li').eq(n).position().left;
    $('.p-top-mv__dots__ind').css('width', between + width);
  });
});
